import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import { getSliceCategory, getSliceSubCategory } from '../../selectors';
import DefaultCard from '../Card';
import styleTiles from '../../styles/tiles';
import SideScroller from '../Scrollers/SideScroller';
import { cardType, colourThemeType } from '../../propTypes';
import theme, { sliceColourTheme } from '../../styles/theme';

const CAROUSEL_MAX_VISIBLE_TILES = 6;
const MIN_TILE_WIDTH = 164;
const MOBILE_MAX_TILE_WIDTH = 164;
const DESKTOP_MAX_TILE_WIDTH = 200;

class Cards extends PureComponent {
  componentDidUpdate(prevProps) {
    const { category: prevCategory, subCategory: prevSubCategory } = prevProps;
    const { category, subCategory } = this.props;
    if (this.swiper && (category !== prevCategory || subCategory !== prevSubCategory)) {
      this.swiper.update();
      this.swiper.slideTo(0, 0);
    }
  }

  setSwiperRef = swiper => {
    this.swiper = swiper;
  };

  render() {
    const {
      Card, cards, classes, className, ready, colourTheme, adId,
    } = this.props;
    return (
      <SideScroller
        slideClassName={classes.card}
        className={cn(className, classes.cards)}
        swiperRef={this.setSwiperRef}
        ready={ready}
        centerInsufficientSlides
        colourTheme={colourTheme}
        slidesOffsetBefore={0}
        slidesOffsetAfter={0}
      >
        {cards.map(({ visible, ...card }, i) => (
          <Card
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            listIndex={i}
            className={cn(classes.card, !visible && classes.excludedCard, 'ti-cs-side-scroller-card-item')}
            {...card}
            colourTheme={colourTheme}
            adId={adId}
          />
        ))}
      </SideScroller>
    );
  }
}

Cards.propTypes = {
  Card: PropTypes.func,
  category: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  cards: PropTypes.arrayOf(cardType).isRequired,
  ready: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  subCategory: PropTypes.string,
  colourTheme: colourThemeType,
  adId: PropTypes.string,
};

Cards.defaultProps = {
  Card: DefaultCard,
  category: undefined,
  className: undefined,
  ready: true,
  subCategory: undefined,
  colourTheme: sliceColourTheme.white,
  adId: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  category: getSliceCategory(state, sliceId),
  subCategory: getSliceSubCategory(state, sliceId),
});

const tileStyles = styleTiles('card', 'cards', CAROUSEL_MAX_VISIBLE_TILES);

export default compose(
  connect(mapStateToProps),

  injectSheet({
    ...tileStyles,
    card: {
      ...tileStyles.card,
      // DEV NOTE: Stopped using theme.padding.gutter on margins so value is clear
      margin: 4,
      // DEV NOTE: Cap tile/cards width at 164px on mobile below 768px
      minWidth: MIN_TILE_WIDTH,
      maxWidth: MOBILE_MAX_TILE_WIDTH,
      // DEV NOTE: On desktop allow tiles to grow up to 200px
      [theme.breakpoints.up('md')]: {
        maxWidth: DESKTOP_MAX_TILE_WIDTH,
      },
      [theme.breakpoints.up('xl')]: {
        margin: 8,
        // Allow to shrink below min width to prioritise number of visible tiles
        minWidth: 0,
        // DEV NOTE: theme.padding.gutter (16px) is the total left+right margin per tile
        width: `calc((100% - ${theme.padding.gutter * CAROUSEL_MAX_VISIBLE_TILES}px) / ${CAROUSEL_MAX_VISIBLE_TILES})`,
      },
    },
    excludedCard: {
      display: 'none',
    },
  }),
)(Cards);
